'use client';

import { useTranslation } from 'react-i18next';

import { toast } from '@kit/ui/sonner';

import type { UserType } from '../../schema/professional-profile.schema';
import { getTrialPeriodDays } from './constants';
import { saveProfileAction } from './save-profile-action';

const GA_MEASUREMENT_ID = process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID;
const SIGNUP_WIZARD_CONVERSION_LABEL = 'JDhyCKDZsZIcELmIvpVD';

interface ProfileFormData {
  userId: string;
  userType: UserType;
  publicData: Record<string, string | undefined>;
}

export function useProfileFormSubmit(onComplete: () => void) {
  const { t } = useTranslation('account');

  const submitProfile = async (data: ProfileFormData) => {
    try {
      const result = await saveProfileAction({
        userId: data.userId,
        userType: data.userType,
        publicData: data.publicData,
      });

      if (result.success) {
        toast.success(
          t('profileWizard.saveSuccess', { days: getTrialPeriodDays() }),
        );

        // Fire Google Ads signup-with-wizard conversion
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const gtag = (window as any).gtag;
        if (typeof gtag === 'function' && GA_MEASUREMENT_ID) {
          gtag('event', 'conversion', {
            send_to: `${GA_MEASUREMENT_ID}/${SIGNUP_WIZARD_CONVERSION_LABEL}`,
          });
        }

        onComplete();
      } else {
        toast.error(result.error ?? t('profileWizard.saveError'));
      }
    } catch {
      toast.error(t('profileWizard.saveError'));
    }
  };

  return { submitProfile };
}
